import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { api } from '../services/apiClient';

const useUserStore = create(
  persist(
    (set, get) => ({
      token: null,
      isLoggedIn: false,
      userInfo: {
        id: null,
        username: '',
        email: '',
        avatar: '👤',
        joinDate: '',
        level: '普通用户',
        parentInviteCode: '',
        myInviteCode: '',
        binanceUID: '',
        bitgetUID: '',
        wechat: '',
        okxUID: '',
        is_verified: false,
        user_type: '普通用户',
      },

      /** 登录成功后调用 */
      login: (token, userData) => {
        set({
          token,
          isLoggedIn: true,
          userInfo: {
            id: userData.id || null,
            username: userData.nickname || userData.email || '',
            email: userData.email || '',
            avatar: '👤',
            joinDate: userData.joinDate || '',
            level: '普通用户',
            parentInviteCode: userData.parentInviteCode || '',
            myInviteCode: userData.inviteCode || '',
            binanceUID: userData.binanceUID || '',
            bitgetUID: userData.bitgetUID || '',
            wechat: userData.wechat || '',
            okxUID: userData.okxUID || '',
            is_verified: userData.isVerified === true,
            user_type: userData.userType || '普通用户',
          },
        });
      },

      /** 登出 */
      logout: () => {
        set({
          token: null,
          isLoggedIn: false,
          userInfo: {
            id: null, username: '', email: '', avatar: '👤',
            joinDate: '', level: '普通用户',
            parentInviteCode: '', myInviteCode: '',
            binanceUID: '', bitgetUID: '', wechat: '', okxUID: '',
            is_verified: false, user_type: '普通用户',
          },
        });
      },

      /** 页面刷新后校验 token 恢复登录 */
      verifySession: async () => {
        const { token } = get();
        if (!token) return false;
        try {
          const data = await api.verifyToken(token);
          if (data.valid && data.user) {
            set({
              isLoggedIn: true,
              userInfo: {
                id: data.user.id || null,
                username: data.user.nickname || data.user.email || '',
                email: data.user.email || '',
                avatar: '👤',
                joinDate: data.user.joinDate || '',
                level: '普通用户',
                parentInviteCode: data.user.parentInviteCode || '',
                myInviteCode: data.user.inviteCode || '',
                binanceUID: data.user.binanceUID || '',
                bitgetUID: data.user.bitgetUID || '',
                wechat: data.user.wechat || '',
                okxUID: data.user.okxUID || '',
                is_verified: data.user.isVerified === true,
                user_type: data.user.userType || '普通用户',
              },
            });
            return true;
          }
          // Token invalid, log out
          get().logout();
          return false;
        } catch {
          get().logout();
          return false;
        }
      },

      /** 仅更新前端用户信息（Profile 页用） */
      updateUserInfo: (newInfo) => {
        set((state) => ({
          userInfo: {
            ...state.userInfo,
            ...newInfo,
            username: newInfo.nickname || state.userInfo.username,
          },
        }));
      },
    }),
    {
      name: 'user-storage',
      partialize: (state) => ({
        token: state.token,
        isLoggedIn: state.isLoggedIn,
        userInfo: state.userInfo,
      }),
      migrate: (persistedState, _version) => ({
        ...persistedState,
        isLoggedIn: persistedState?.isLoggedIn ?? false,
        userInfo: {
          ...persistedState?.userInfo,
          is_verified: persistedState?.userInfo?.is_verified ?? false,
          user_type: persistedState?.userInfo?.user_type || '普通用户',
        },
        token: persistedState?.token || null,
      }),
      version: 1,
    }
  )
);

export default useUserStore;
